import { SocialAccountInfo } from "@ui/molecules/SocialAccountInfo/SocialAccountInfo.jsx";
import { HStack, VStack } from "@ui/Stack.jsx";
import { Text } from "@ui/typography/Text";
import { createMemo, For } from "solid-js";
import type { MentionData } from "../Mention";
import { ProfilePanelSocial } from "./ProfilePanelSocial";

export const ChannelSummary = (props: { mention: MentionData }) => {
	const followerCounts = createMemo(
		() => props.mention.all_follower_counts ?? [],
	);

	return (
		<VStack class="mention-profile-summary" spacing="medium">
			<SocialAccountInfo
				platform={props.mention.platform}
				handle={props.mention.handle}
				name={props.mention.name}
				avatar={props.mention.profile_picture_url}
			/>
			<Text size="small" color="fg2">
				{props.mention.bio ?? ""}
			</Text>

			<HStack class="platform-follower-counts" spacing="small" fullWidth>
				<For each={followerCounts()}>
					{(item) => (
						<ProfilePanelSocial
							platform={{
								...item,
								handle: `@${props.mention.handle}`,
								profile_url: props.mention.profile_url,
							}}
						/>
					)}
				</For>
			</HStack>
		</VStack>
	);
};
